/** Cliente Colyseus para o RunRoom autoritativo (co-op, M2). */
import { Client, type Room } from '@colyseus/sdk';

export interface JoinCoopOpts {
  seed: number;
  playerCount: number;
  url?: string;
}

export function serverUrl(): string {
  // dev/E2E: servidor Colyseus na 2567 do mesmo host
  const host = typeof location !== 'undefined' ? location.hostname : 'localhost';
  return `ws://${host}:2567`;
}

export async function joinCoop(opts: JoinCoopOpts): Promise<Room> {
  const client = new Client(opts.url ?? serverUrl());
  return client.joinOrCreate('run', { seed: opts.seed, playerCount: opts.playerCount });
}
